import { useTranslation } from 'react-i18next';
import { isNil } from 'lodash-es';

import { SURVEY_ANSWER_TYPE, SURVEY_QUESTION_TYPE } from '@/services/dictionaries/SurveyQuestionTypes';
import { SurveySectionType } from '../OnboardingSurveyInterface';
import { useGetSurveyVariant } from './useGetSurveyVariant';

export const useSurveyContentConfig = () => {
    const { t } = useTranslation();
    const surveyContent = useGetSurveyVariant();

    const surveySections = surveyContent?.sections.map((section) => ({
        id: section.id,
        title: t(section.title),
        displayTitle: t(section.displayTitle),
        displayDescription: t(section.displayDescription),
        questions: section.questions.map((question) => ({
            ...question,
            translatedTitle: t(question.translatedTitle),
            description: t(question.description),
            type: SURVEY_QUESTION_TYPE[question.type],
            answers: question.answers?.map((answer) => ({
                ...answer,
                translatedTitle: !isNil(answer.translatedTitle) ? t(answer.translatedTitle) : answer.title,
                placeholder: t(answer.placeholder),
                type: SURVEY_ANSWER_TYPE[answer.type],
            })),
        })),
    })) as SurveySectionType[];

    return {
        formId: surveyContent.formId,
        sections: surveySections,
        bannerText: t(surveyContent.bannerText),
    };
};
